import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=628d30de&"
import script from "./ReportsList.js?vue&type=script&lang=js&"
export * from "./ReportsList.js?vue&type=script&lang=js&"
import style0 from "./ReportsList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports